import { useLayoutEffect, useMemo, useState } from 'react';
import { SubscriptionDto } from '@/Domain/api/Subscription/dto/Subscription.dto';
import { SubscriptionPlansDto } from '@/Domain/api/Subscription/dto/SubscriptionPlans.dto';
import { BillingPortalCard } from '@/Domain/components/Subscription/BillingPortalCard';
import { FailedPaymentAlert } from '@/Domain/components/Subscription/FailedPaymentAlert';
import { MembershipCard } from '@/Domain/components/Subscription/MembershipCard/MembershipCard';
import { OnboardingDiscountBanner } from '@/Domain/components/Subscription/OnboardingDiscountBanner';
import { PricingPlans } from '@/Domain/components/Subscription/PricingPlans/PricingPlans';
import { SubscriptionIntervalEnum } from '@/Domain/enum/SubscriptionInterval.enum';
import { SubscriptionHelper } from '@/Domain/helper/Subscription.helper';

export type StripeData = {
  currentPlan: SubscriptionDto['current_plan'];
  subscription: SubscriptionDto['subscription'];
  plans: SubscriptionPlansDto['products'];
  pricing: SubscriptionPlansDto['subscriptions'];
};

export const SubscriptionPage = (stripeData: StripeData) => {
  const { currentPlan, subscription, plans } = stripeData;
  const [isBillingYearly, setIsBillingYearly] = useState(false);

  const interval = useMemo(
    () => (isBillingYearly ? SubscriptionIntervalEnum.Annually : SubscriptionIntervalEnum.Monthly),
    [isBillingYearly],
  );

  useLayoutEffect(() => {
    if (stripeData.currentPlan.interval === SubscriptionIntervalEnum.Annually) {
      setIsBillingYearly(true);
    }
  }, [stripeData.currentPlan.interval]);

  return (
    <div>
      {subscription.payment_failed && (
        <div className="mb-4">
          <FailedPaymentAlert />
        </div>
      )}
      <OnboardingDiscountBanner />
      <div className="flex flex-col gap-18">
        <section>
          <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-3">
            <MembershipCard
              isBillingYearly={isBillingYearly}
              subscription={subscription}
              currentPlan={currentPlan}
              plans={plans}
              interval={interval}
            />
            <BillingPortalCard
              isPaymentFailed={subscription.payment_failed}
              isFreeAccount={SubscriptionHelper.isFreeAccount(currentPlan.tier)}
            />
          </div>
        </section>

        <PricingPlans
          stripeData={stripeData}
          isBillingYearly={isBillingYearly}
          onBillingYearlyChange={setIsBillingYearly}
        />
      </div>
    </div>
  );
};
